<app-partner-search #selectSearch (changeEvent)="change($event)"
                    [placeHolder]="placeHolder"
                    [typeValue]="typeValue"
                    [parentFormGroup]="parentFormGroup"
                    [parentFormControlName]="parentFormControlName"
                    [newItemModalOptions]="formattedNewItemModalOptions"
                    [noEntryPlaceHolder]="noEntryPlaceHolder"
                    [value]="value"
                    [parameterSearch]="parameterSearch"
                    [automaticSelectIfOneResult]="automaticSelectIfOneResult"
                    [searchTerm]="searchTerm">
</app-partner-search>
